import * as React from 'react'
import * as ReactDOM from 'react-dom'
import 'core-js-pure/stable'
import 'regenerator-runtime/runtime'
import 'react-toastify/dist/ReactToastify.css'
import App from './app'
if (process.env.NODE_ENV !== 'development')
    console.log = () => {}
ReactDOM.render(<App />, document.getElementById('app'))
